/**
 * 問診フローの質問データと選択肢
 */

import type {
  CategoryOption,
  DurationOption,
  MedicalVisitOption,
  TargetAge,
  TargetGender,
} from './types';

/**
 * 質問の選択肢データ型
 */
export interface QuestionOption<T = string> {
  value: T;
  label: string;
  subtitle?: string;
}

/**
 * 年代・性別の選択肢の型
 */
export interface AgeOption {
  value: TargetAge;
  label: string;
}

export interface GenderOption {
  value: TargetGender;
  label: string;
}

/**
 * カテゴリ選択の質問データ
 */
export const categoryOptions: QuestionOption<CategoryOption>[] = [
  {
    value: 'should_go_hospital',
    label: '病院に行くべき？',
    subtitle: '緊急性・受診目安を知りたい',
  },
  {
    value: 'which_department',
    label: '何科に行けばいい？',
    subtitle: '適切な診療科・場所を知りたい',
  },
  {
    value: 'cause',
    label: '原因は？',
    subtitle: '症状の原因・考えられる病気を知りたい',
  },
  {
    value: 'how_to_deal',
    label: '対処法は？',
    subtitle: '日常生活で気をつけることを知りたい',
  },
  {
    value: 'medicine_treatment',
    label: '薬や治療法は？',
    subtitle: '薬の効果や副作用・飲み合わせを知りたい',
  },
  {
    value: 'other',
    label: 'その他',
    subtitle: 'あてはまるものがない',
  },
];

/**
 * 期間選択の質問データ
 */
export const durationOptions: QuestionOption<DurationOption>[] = [
  { value: 'today', label: '今日初めて気づいた' },
  { value: 'yesterday', label: '昨日から' },
  { value: 'few_days', label: '2,3日以内' },
  { value: 'within_week', label: '1週間以内から' },
  { value: 'over_week', label: '1週間以上前から' },
  { value: 'no_symptom', label: '症状は無い・当てはまらない' },
];

/**
 * 受診状況選択の質問データ
 */
export const medicalVisitOptions: QuestionOption<MedicalVisitOption>[] = [
  { value: 'before', label: '受診前', subtitle: 'これから行く・検討中' },
  { value: 'during', label: '通院中', subtitle: '現在治療のため通院している' },
  { value: 'after', label: '受診後', subtitle: '治った・もう行っていない' },
];

/**
 * 年代・性別の選択肢
 */
export const ageOptions: AgeOption[] = [
  { value: 'INFANTS', label: '乳幼児' },
  { value: 'UNDER_10', label: '10歳未満' },
  { value: 'RANGE_10_19', label: '10代' },
  { value: 'RANGE_20_29', label: '20代' },
  { value: 'RANGE_30_39', label: '30代' },
  { value: 'RANGE_40_49', label: '40代' },
  { value: 'RANGE_50_59', label: '50代' },
  { value: 'RANGE_60_69', label: '60代' },
  { value: 'OVER_70', label: '70代以上' },
];

export const genderOptions: GenderOption[] = [
  { value: 'M', label: '男性' },
  { value: 'F', label: '女性' },
];

/**
 * セレクトボックス用の選択肢（未選択オプション付き）
 */
export const ageSelectOptions: AgeOption[] = [
  { value: 'NOT_SELECTED', label: '年代を選択' },
  ...ageOptions,
];

export const genderSelectOptions: GenderOption[] = [
  { value: 'NOT_SELECTED', label: '性別を選択' },
  ...genderOptions,
];
